
<template>
  <div>
    <a-card :bordered="false">
      <div>
        <a-tabs defaultActiveKey="1" @change="tabChange">
          <a-tab-pane tab="预约号发卡" key="1" forceRender>
            <a-alert v-if="msg" v-bind:message="this.msg" :type="msgType" showIcon />
            <a-form v-if="tabkey == 1" :form="form" :activeon="activeon">
              <a-form-item label="卡号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
                <a-input
                  ref="cardNo1"
                  class="cardno"
                  @pressEnter="cardVoEnter($event)"
                  @change="changeMsg($event)"
                  onfocus=" this.style.imeMode='inactive'"
                  oninput="if(value.length >9) value = value.slice(0, 10) "
                  placeholder="请输入卡号"
                  v-decorator="['cardNo1', { rules: [{ required: true, message: '请输入卡号' }] }]"
                />
              </a-form-item>
              <a-form-item label="预约验证码" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
                <a-input
                  @change="changeYzm"
                  placeholder="请输入预约验证码"
                  v-decorator="['verificationCode', { rules: [{ required: true, message: '请输入预约验证码' }] }]"
                />
              </a-form-item>

              <a-form-item label="车号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
                <a-input placeholder="车号" v-model="carNoYzm" />
              </a-form-item>

              <a-form-item label="识别车号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
                <a-input v-model="monitorCarNo" placeholder="请输入识别车号" />
              </a-form-item>

              <a-form-item>
                <a-button class="btn" type="primary" @click="canQuery">查询</a-button>
              </a-form-item>
              <div v-if="canGrantCardList && canGrantCardList.length > 0" class="grant-list-box">
                <hr style="margin-bottom: 20px" />
                <span class="tipspan">&nbsp;请选择一条记录然后【发卡】</span>
                <div v-for="iten in canGrantCardList">
                  <div :id="iten.logisticsNo + 'bdiv'" v-on:click="selectGrant(iten.logisticsNo)">
                    <div class="item-chick">
                      <a-checkbox :ref="'ckb' + iten.logisticsNo" class="item-ckb ckb"></a-checkbox>
                    </div>
                    <div class="item-div sdiv" :id="iten.logisticsNo + 'sdiv'">
                      <table class="stable">
                        <tr>
                          <th>驾驶员：</th>
                          <td>{{ iten.driverName }}</td>
                          <th>车号：</th>
                          <td>{{ iten.vehicleNo }}</td>
                          <th>手机号：</th>
                          <td>{{ iten.phone }}</td>
                        </tr>
                        <tr>
                          <th>客户：</th>
                          <td>{{ iten.corpBusinessName }}</td>
                          <th>供应商：</th>
                          <td>{{ iten.corpSupplierName }}</td>
                          <th>货物：</th>
                          <td :rowspan="iten.materielList.length">
                            <span v-for="(m, i) in iten.materielList">
                              {{ m.materielName }}
                              <br v-if="i < iten.materielList.length" />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <th>业务类型：</th>
                          <td>{{ iten.businessTypeName }}</td>
                          <th>身份证号：</th>
                          <td>{{ iten.idcard }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <br />
                </div>
                <a-form-item>
                  <a-button class="btn" type="primary" @click="grantCard" :loading="confirmLoading">发卡</a-button>
                </a-form-item>
              </div>
            </a-form>
          </a-tab-pane>
          <a-tab-pane tab="车号发卡" key="2" forceRender>
            <a-alert v-if="msg" v-bind:message="this.msg" :type="msgType" showIcon />
            <a-form v-if="tabkey == 2" :form="form" :activeon="activeon">
              <a-form-item label="通道" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
                <a-radio-group
                  v-decorator="['road', { rules: [{ required: true, message: '请选择通道'}]}]"
                  @change="changeRoad"
                >
                  <a-radio-button
                    v-for="(item, index) in [{value: '1', name: '通道1'},{value: '2', name: '通道2'}]"
                    :key="index"
                    :value="item.value"
                  >{{ item.name }}</a-radio-button>
                </a-radio-group>
              </a-form-item>
              <a-form-item label="卡号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
                <a-input
                  ref="cardNo2"
                  class="cardno"
                  @pressEnter="cardVoEnter($event)"
                  @change="changeMsg($event, 'car')"
                  onfocus=" this.style.imeMode='inactive'"
                  placeholder="请输入卡号"
                  v-decorator="['cardNo', { rules: [{ required: true, message: '请输入卡号' }] }]"
                />
              </a-form-item>
              <a-form-item label="车号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
                <a-auto-complete
                  style="max-width: 654.717px"
                  placeholder=""
                  v-decorator="[
                    'vehicleNo',
                    { initialValue: vehicleNo, rules: [{ required: true, message: '请输入车号' }] },
                  ]"
                />
              </a-form-item>
              <a-form-item>
                <a-button class="btn" type="primary" @click="canQuery">查询</a-button>
              </a-form-item>
              <div v-if="canGrantCardList && canGrantCardList.length > 0" class="grant-list-box">
                <hr style="margin-bottom: 20px" />
                <span class="tipspan">&nbsp;请选择一条记录然后【发卡】</span>
                <div v-for="iten in canGrantCardList">
                  <div :id="iten.logisticsNo + 'bdiv'" v-on:click="selectGrant(iten.logisticsNo)">
                    <div class="item-chick">
                      <a-checkbox :ref="'ckb' + iten.logisticsNo" class="item-ckb ckb"></a-checkbox>
                    </div>
                    <div class="item-div sdiv" :id="iten.logisticsNo + 'sdiv'">
                      <table class="stable">
                        <tr>
                          <th>驾驶员：</th>
                          <td>{{ iten.driverName }}</td>
                          <th>车号：</th>
                          <td>{{ iten.vehicleNo }}</td>
                          <th>手机号：</th>
                          <td>{{ iten.phone }}</td>
                        </tr>
                        <tr>
                          <th>客户：</th>
                          <td>{{ iten.corpBusinessName }}</td>
                          <th>供应商：</th>
                          <td>{{ iten.corpSupplierName }}</td>
                          <th>货物：</th>
                          <td :rowspan="iten.materielList.length">
                            <span v-for="(m, i) in iten.materielList">
                              {{ m.materielName }}
                              <br v-if="i < iten.materielList.length" />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <th>业务类型：</th>
                          <td>{{ iten.businessTypeName }}</td>
                          <th>身份证号：</th>
                          <td>{{ iten.idcard }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <br />
                </div>
                <a-form-item>
                  <a-button class="btn" type="primary" @click="grantCard" :loading="confirmLoading">发卡</a-button>
                </a-form-item>
              </div>
            </a-form>
          </a-tab-pane>
          <a-tab-pane tab="预约手机号发卡" key="3" forceRender>
            <a-alert v-if="msg" v-bind:message="this.msg" :type="msgType" showIcon />
            <a-form v-if="tabkey == 3" :form="form" :activeon="activeon">
              <a-form-item label="卡号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
                <a-input
                  ref="cardNo3"
                  class="cardno"
                  @pressEnter="cardVoEnter($event)"
                  @change="changeMsg($event)"
                  onfocus=" this.style.imeMode='inactive'"
                  placeholder="请输入卡号"
                  v-decorator="['cardNo', { rules: [{ required: true, message: '请输入卡号' }] }]"
                />
              </a-form-item>
              <a-form-item label="预约手机号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
                <a-input
                  @change="changeMsg($event)"
                  placeholder="请输入预约手机号"
                  v-decorator="['phone', { rules: [{ required: true, message: '请输入预约手机号' }] }]"
                />
              </a-form-item>
              <a-form-item>
                <a-button class="btn" type="primary" @click="canQuery">查询</a-button>
              </a-form-item>
              <div v-if="canGrantCardList && canGrantCardList.length > 0" class="grant-list-box">
                <hr style="margin-bottom: 20px" />
                <span class="tipspan">&nbsp;请选择一条记录然后【发卡】</span>
                <div v-for="iten in canGrantCardList">
                  <div :id="iten.logisticsNo + 'bdiv'" v-on:click="selectGrant(iten.logisticsNo)">
                    <div class="item-chick">
                      <a-checkbox :ref="'ckb' + iten.logisticsNo" class="item-ckb ckb"></a-checkbox>
                    </div>
                    <div class="item-div sdiv" :id="iten.logisticsNo + 'sdiv'">
                      <table class="stable">
                        <tr>
                          <th>驾驶员：</th>
                          <td>{{ iten.driverName }}</td>
                          <th>车号：</th>
                          <td>{{ iten.vehicleNo }}</td>
                          <th>手机号：</th>
                          <td>{{ iten.phone }}</td>
                        </tr>
                        <tr>
                          <th>客户：</th>
                          <td>{{ iten.corpBusinessName }}</td>
                          <th>供应商：</th>
                          <td>{{ iten.corpSupplierName }}</td>
                          <th>货物：</th>
                          <td :rowspan="iten.materielList.length">
                            <span v-for="(m, i) in iten.materielList">
                              {{ m.materielName }}
                              <br v-if="i < iten.materielList.length" />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <th>业务类型：</th>
                          <td>{{ iten.businessTypeName }}</td>
                          <th>身份证号：</th>
                          <td>{{ iten.idcard }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <br />
                </div>
                <a-form-item>
                  <a-button class="btn" type="primary" @click="grantCard" :loading="confirmLoading">发卡</a-button>
                </a-form-item>
              </div>
            </a-form>
          </a-tab-pane>
          <a-tab-pane tab="身份证号发卡" key="4" forceRender>
            <a-alert v-if="msg" v-bind:message="this.msg" :type="msgType" showIcon />
            <a-form v-if="tabkey == 4" :form="form" :activeon="activeon">
              <a-form-item label="卡号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
                <a-input
                  ref="cardNo4"
                  class="cardno"
                  @pressEnter="cardVoEnter($event)"
                  @change="changeMsg($event)"
                  onfocus=" this.style.imeMode='inactive'"
                  placeholder="请输入卡号"
                  v-decorator="['cardNo', { rules: [{ required: true, message: '请输入卡号' }] }]"
                />
              </a-form-item>
              <a-form-item label="身份证号" :label-col="{ span: 6 }" :wrapper-col="{ span: 12 }">
                <a-input
                  @change="changeMsg($event)"
                  placeholder="请输入身份证号"
                  v-decorator="['idCard', { rules: [{ required: true, message: '请输入身份证号' }] }]"
                />
              </a-form-item>
              <a-form-item>
                <a-button class="btn" type="primary" @click="canQuery">查询</a-button>
              </a-form-item>
              <div v-if="canGrantCardList && canGrantCardList.length > 0" class="grant-list-box">
                <hr style="margin-bottom: 20px" />
                <span class="tipspan">&nbsp;请选择一条记录然后【发卡】</span>
                <div v-for="iten in canGrantCardList">
                  <div :id="iten.logisticsNo + 'bdiv'" v-on:click="selectGrant(iten.logisticsNo)">
                    <div class="item-chick">
                      <a-checkbox :ref="'ckb' + iten.logisticsNo" class="item-ckb ckb"></a-checkbox>
                    </div>
                    <div class="item-div sdiv" :id="iten.logisticsNo + 'sdiv'">
                      <table class="stable">
                        <tr>
                          <th>驾驶员：</th>
                          <td>{{ iten.driverName }}</td>
                          <th>车号：</th>
                          <td>{{ iten.vehicleNo }}</td>
                          <th>手机号：</th>
                          <td>{{ iten.phone }}</td>
                        </tr>
                        <tr>
                          <th>客户：</th>
                          <td>{{ iten.corpBusinessName }}</td>
                          <th>供应商：</th>
                          <td>{{ iten.corpSupplierName }}</td>
                          <th>货物：</th>
                          <td :rowspan="iten.materielList.length">
                            <span v-for="(m, i) in iten.materielList">
                              {{ m.materielName }}
                              <br v-if="i < iten.materielList.length" />
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <th>业务类型：</th>
                          <td>{{ iten.businessTypeName }}</td>
                          <th>身份证号：</th>
                          <td>{{ iten.idcard }}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <br />
                </div>
                <a-form-item>
                  <a-button class="btn" type="primary" @click="grantCard" :loading="confirmLoading">发卡</a-button>
                </a-form-item>
              </div>
            </a-form>
          </a-tab-pane>
          <a-tab-pane tab="无预约发卡" key="5" forceRender>
            <reservationAdd zzshr="1"></reservationAdd>
          </a-tab-pane>
          <a-tab-pane tab="收卡" key="6">
            <a-alert v-if="msg" v-bind:message="this.msg" :type="msgType" showIcon />
            <a-form :form="form">
              <a-form-item
                label="卡号"
                :label-col="{ span: 6 }"
                :wrapper-col="{ span: 12 }"
                :validate-status="mdl.cardNo == '' ? 'error' : ''"
                :help="mdl.cardNo == '' ? '请输入卡号' : ''"
              >
                <a-input
                  ref="cardNo6"
                  class="cardno"
                  @pressEnter="cardVoEnterRecovery($event)"
                  @change="changeMsg($event)"
                  v-model="recoveryCard"
                  onfocus=" this.style.imeMode='inactive'"
                  placeholder="请输入卡号"
                  v-decorator="['cardNo', { rules: [{ required: true, message: '请输入卡号' }] }]"
                />
              </a-form-item>
              <a-form-item>
                <a-button class="btn" type="primary" @click="recoveryCardQuery" :loading="confirmLoading"
                  >查询</a-button
                >
              </a-form-item>
            </a-form>
          </a-tab-pane>
        </a-tabs>
      </div>

      <a-modal class="dy01" title="收卡确认" style="top: 20px" :width="800" v-model="recovery" @cancel="recoveryCancel">
        <template slot="footer">
          <div v-if="recoverymdl" style="text-align: center">
            <a-form-item label="识别车号" :label-col="{ span: 8 }" :wrapper-col="{ span: 8 }">
              <a-input v-model="recoveryCarNo" placeholder="请输入识别车号" />
            </a-form-item>
            <a-button type="primary" @click="printPreview(recoverymdl.logisticsNo)">打印磅单</a-button>
            <a-divider type="vertical" />
            <a-button type="primary" @click="handleRecoveryOk(recoverymdl.logisticsNo)" :loading="confirmLoading"
              >收卡</a-button
            >
          </div>
        </template>

        <table class="stable" v-if="recoverymdl">
          <tr>
            <th style="width: 15%">驾驶员：</th>
            <td style="width: 35%">{{ recoverymdl.driverName }}</td>
            <th style="width: 15%">车号：</th>
            <td style="width: 35%">{{ recoverymdl.vehicleNo }}</td>
          </tr>
          <tr>
            <th>手机号：</th>
            <td>{{ recoverymdl.phone }}</td>
            <th>客户：</th>
            <td>{{ recoverymdl.corpBusinessName }}</td>
          </tr>
          <tr>
            <th>业务类型：</th>
            <td>{{ recoverymdl.businessTypeName }}</td>
            <th>身份证号：</th>
            <td>{{ recoverymdl.idcard }}</td>
          </tr>
          <tr>
            <th>供应商：</th>
            <td>{{ recoverymdl.corpSupplierName }}</td>
            <th>货物：</th>
            <td v-if="recoverymdl.materielList" :rowspan="recoverymdl.materielList.length">
              <span v-for="(m, i) in recoverymdl.materielList">
                {{ m.materielName }}
                <br v-if="recoverymdl.materielList && i < recoverymdl.materielList.length" />
              </span>
            </td>
          </tr>
        </table>
      </a-modal>

      <div id="dy01" v-if="print" style="display: none">
        <div style="width: 680px">
          <div style="height: 10px; line-height: 10px"></div>
          <div style="height: 20px; line-height: 20px; font-size: 30px; text-align: center; font-weight: 900">
            安陆顺安矿业过磅单
          </div>
          <div style="height: 25px; display: flex; justify-content: space-between; margin-top: 20px">
            <div><span style="font-weight: 600">日期：</span>{{ print.dbDate }}</div>
            <div><span style="font-weight: 600">单位：</span>吨</div>
            <div style="margin-right: 40px"><span style="font-weight: 600">单号：</span>{{ print.logisticsNo }}</div>
          </div>
          <div style="border: 1px solid black; height: 300; width: 100%; display: flex; flex-flow: row wrap">
            <div style="width: 55%; display: flex">
              <div
                style="
                  width: 24.8%;
                  text-align: center;
                  border: 1px solid black;
                  height: 26px;
                  line-height: 26px;
                  font-weight: 600;
                "
              >
                进厂日期
              </div>
              <div style="width: 75.2%; text-align: center; border: 1px solid black; height: 26px; line-height: 26px">
                {{ print.inTime }}
              </div>
            </div>
            <div style="width: 45%; display: flex">
              <div
                style="
                  width: 24%;
                  text-align: center;
                  border: 1px solid black;
                  height: 26px;
                  line-height: 26px;
                  font-weight: 600;
                "
              >
                出厂日期
              </div>
              <div style="width: 76%; text-align: center; border: 1px solid black; height: 26px; line-height: 26px">
                {{ print.outTime }}
              </div>
            </div>
            <div style="width: 55%; display: flex">
              <div
                style="
                  width: 24.8%;
                  text-align: center;
                  border: 1px solid black;
                  height: 26px;
                  line-height: 26px;
                  font-weight: 600;
                "
              >
                发货单位
              </div>
              <div style="width: 75.2%; text-align: center; border: 1px solid black; height: 26px; line-height: 26px">
                安陆顺安矿业
              </div>
            </div>
            <div style="width: 45%; display: flex">
              <div
                style="
                  width: 24%;
                  text-align: center;
                  border: 1px solid black;
                  height: 26px;
                  line-height: 26px;
                  font-weight: 600;
                "
              >
                收货单位
              </div>
              <div style="width: 76%; text-align: center; border: 1px solid black; height: 26px; line-height: 26px">
                {{ print.corpBusinessName }}
              </div>
            </div>
            <div style="width: 55%; display: flex">
              <div
                style="
                  width: 24.8%;
                  text-align: center;
                  border: 1px solid black;
                  height: 26px;
                  line-height: 26px;
                  font-weight: 600;
                "
              >
                货物名称
              </div>
              <div style="width: 75.2%; text-align: center; border: 1px solid black; height: 26px; line-height: 26px">
                {{ print.materielName }}
              </div>
            </div>
            <div style="width: 45%; display: flex">
              <div
                style="
                  width: 24%;
                  text-align: center;
                  border: 1px solid black;
                  height: 26px;
                  line-height: 26px;
                  font-weight: 600;
                "
              >
                承运单位
              </div>
              <div
                style="width: 76%; text-align: center; border: 1px solid black; height: 26px; line-height: 26px"
              ></div>
            </div>
            <div style="width: 100%; display: flex">
              <div
                style="
                  width: 16.66%;
                  text-align: center;
                  border: 1px solid black;
                  height: 26px;
                  line-height: 26px;
                  font-weight: 600;
                "
              >
                车&emsp;&emsp;&emsp;&emsp;号
              </div>
              <div
                style="
                  width: 16.66%;
                  text-align: center;
                  border: 1px solid black;
                  height: 26px;
                  line-height: 26px;
                  font-weight: 600;
                "
              >
                司&emsp;&emsp;&emsp;&emsp;机
              </div>
              <div
                style="
                  width: 16.66%;
                  text-align: center;
                  border: 1px solid black;
                  height: 26px;
                  line-height: 26px;
                  font-weight: 600;
                "
              >
                电&emsp;&emsp;&emsp;&emsp;话
              </div>
              <div
                style="
                  width: 16.66%;
                  text-align: center;
                  border: 1px solid black;
                  height: 26px;
                  line-height: 26px;
                  font-weight: 600;
                "
              >
                皮&emsp;&emsp;&emsp;&emsp;重
              </div>
              <div
                style="
                  width: 16.66%;
                  text-align: center;
                  border: 1px solid black;
                  height: 26px;
                  line-height: 26px;
                  font-weight: 600;
                "
              >
                毛&emsp;&emsp;&emsp;&emsp;重
              </div>
              <div
                style="
                  width: 16.67%;
                  text-align: center;
                  border: 1px solid black;
                  height: 26px;
                  line-height: 26px;
                  font-weight: 600;
                "
              >
                净&emsp;&emsp;&emsp;&emsp;重
              </div>
            </div>

            <div style="width: 100%; display: flex">
              <div style="width: 16.66%; text-align: center; border: 1px solid black; height: 26px; line-height: 26px">
                {{ print.vehicleNo }}
              </div>
              <div style="width: 16.66%; text-align: center; border: 1px solid black; height: 26px; line-height: 26px">
                {{ print.driverName }}
              </div>
              <div style="width: 16.66%; text-align: center; border: 1px solid black; height: 26px; line-height: 26px">
                {{ print.phone }}
              </div>
              <div style="width: 16.66%; text-align: center; border: 1px solid black; height: 26px; line-height: 26px">
                {{ print.tare }}
              </div>
              <div style="width: 16.66%; text-align: center; border: 1px solid black; height: 26px; line-height: 26px">
                {{ print.gross }}
              </div>
              <div style="width: 16.67%; text-align: center; border: 1px solid black; height: 26px; line-height: 26px">
                {{ print.net }}
              </div>
            </div>

            <div style="width: 100%; display: flex">
              <div
                style="
                  width: 13.6%;
                  text-align: center;
                  border: 1px solid black;
                  height: 26px;
                  line-height: 26px;
                  font-weight: 600;
                "
              >
                备&emsp;&emsp;&emsp;&emsp;注
              </div>
              <div
                style="width: 86.4%; text-align: center; border: 1px solid black; height: 26px; line-height: 26px"
              ></div>
            </div>
          </div>

          <div style="display: flex; justify-content: space-between; margin-top: 20px">
            <div style="width: 12%; text-align: center; height: 26px; line-height: 26px; font-weight: 600">
              司磅员：
            </div>
            <div style="width: 30%; text-align: center; height: 26px; line-height: 26px">{{ print.grossUsername }}</div>
            <div style="width: 10%; text-align: center; height: 26px; line-height: 26px; font-weight: 600">
              监票员：
            </div>
            <div style="width: 10%; text-align: center; height: 26px; line-height: 26px"></div>
            <div style="width: 18%; text-align: center; height: 26px; line-height: 26px"></div>
            <div style="width: 10%; text-align: center; height: 26px; line-height: 26px; font-weight: 600">
              驾驶员：
            </div>
            <div style="width: 10%; text-align: center; height: 26px; line-height: 26px; font-weight: 600"></div>
          </div>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import DetailList from '@/components/tools/DetailList'
import Moment from 'moment'
import {
  grantCard,
  grantCardGetBasicAll,
  grantCardRecoveryCard,
  logisticsFindByVerificationCode,
  grantCardCanQuery,
  grantCardAction,
  recoveryCardCanQuery,
  weighingOrder,
  weighingUpdate
} from '@/api/logistics'
import { businessTypeList, ytsoftFindByType, corpLogisticsList, cardvehicleList, recovercardvehicleList } from '@/api/basic'
import { codeList } from '@/api/sys'
import Bus from '@/layouts/bus'
import reservationAdd from '@/views/logistics/ReservationAdd_multi'
import { checkIDCard } from '../../utils/util'
import { formatDate } from '@/utils/date'
import { getLodop } from '@/tools/lodop/LodopFuncs'

const DetailListItem = DetailList.Item

export default {
  // inject:['changeSpinning'],
  // props: ["spinning"],
  components: {
    DetailList,
    DetailListItem,
    reservationAdd: reservationAdd
  },
  data() {
    return {
      recoveryCarNo: null,
      carNoYzm: null,
      vehicleNo: null,
      monitorCarNo: null,
      mdl: {},
      form: this.$form.createForm(this),
      confirmLoading: false,
      msg: null,
      msgType: 'info',
      tabkey: 1,
      activeon: 1,
      objInfo: null,
      canGrantCardList: [],
      selectLogisticsNo: null,
      recovery: false, // 收卡面板参数
      recoverymdl: {}, // 收卡提示对象
      recoveryCard: null, // 收卡卡号
      LODOP: null, // 声明打印全局变量
      print: null, // 打印磅单对象
      downloadUrl: this.config.downloadUrl,
    }
  },
  created() {

    // this.loadSelectData()
  },
  mounted() {
    this.initPage()
  },
  methods: {
    //  oninput="if(value.length = 10)value = value.slice(0, 10) "

    changeYzm(e) {

    },

    initPage() {
      this.$refs.cardNo1.focus()
    },


    cardVoEnter(e) {
      e.target.value = e.target.value.toUpperCase()
      e.target.select()
    },
    nextstep(e) {
      // 获取下一个节点
      let nextNode = e.currentTarget.parentElement.parentElement.parentElement.parentElement.nextElementSibling
      if (nextNode.lastElementChild !== nextNode.firstElementChild) {
        // 判断下个节点下面如果没有第二节点则为“提交”按钮
        nextNode.lastElementChild.firstElementChild.firstElementChild.firstElementChild.focus()
      } else {
        this.grantCard()
      }
    },
    canQuery() {
      // 可发卡记录查询
      this.msg = null
      Bus.$emit('showSpinning', true, '查询中...')
      this.form.validateFields((err, values) => {

        if (!err) {

          if (this.tabkey == 3) {
            var pattern = /^1[345678]\d{9}$/
            if (!pattern.test(values.phone)) {
              this.msg = '手机号格式不正确'
              this.msgType = 'error'
              Bus.$emit('showSpinning', false)
              return false
            }
          }
          if (this.tabkey == 4) {
            if (!checkIDCard(values.idCard)) {
              this.msg = '身份证号不正确'
              this.msgType = 'error'
              Bus.$emit('showSpinning', false)
              return false
            }
          }
          grantCardCanQuery(Object.assign({}, values))
            .then(res => {
              if (res.code === '0') {
                this.canGrantCardList = res.data
                // 如果有内容，则选择第一个
                if (this.canGrantCardList && this.canGrantCardList.length > 0) {
                  this.selectLogisticsNo = this.canGrantCardList[0].logisticsNo
                  // 留点时间，给vue渲染
                  setTimeout(() => {
                    this.selectGrant(this.selectLogisticsNo)
                  }, 100)
                  //校验车号
                  console.log("弹出" + res.data[0].monitorCarNo);
                  this.carNoYzm = res.data[0].vehicleNo;
                  this.monitorCarNo = res.data[0].monitorCarNo[0]
                } else {
                  this.msg = '没有未开卡的预约记录，请先预约！'
                  this.msgType = 'info'
                }
              } else {
                this.msg = res.message
                this.msgType = 'error'
              }
            })
            .catch(e => { })
            .finally(() => {
              Bus.$emit('showSpinning', false)
            })
        } else {
          Bus.$emit('showSpinning', false)
        }
      })
    },
    selectGrant(e) {
      // 选中发卡
      this.selectLogisticsNo = e
      // 处理面板选中样式
      $('.sdiv').css('border', '1px dashed #888')
      $('#' + e + 'sdiv').css('border', '3px double #00F')
      // 处理复选框选中样式
      this.canGrantCardList.forEach(element => {
        if (this.$refs['ckb' + element.logisticsNo]) this.$refs['ckb' + element.logisticsNo][0].checked = false
      })
      this.$refs['ckb' + e][0].checked = true
    },
    grantCard() {
      this.msg = null
      if (this.tabkey < 6) {
        Bus.$emit('showSpinning', true, '发卡中...')
      } else if (this.tabkey == 6) {
        Bus.$emit('showSpinning', true, '收卡中...')
      } else {
        Bus.$emit('showSpinning', true)
      }

      // 表单验证
      // this.form = this.$form.createForm(this)
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          Object.assign(values, this.mdl)
          values.logisticsNo = this.selectLogisticsNo
          let reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
          if (reg.test(values.cardNo)) {
            this.msg = '卡号不能有汉字'
            this.msgType = 'error'
            Bus.$emit('showSpinning', false)
            return
          }
          if (this.tabkey < 6) {
            grantCardAction(Object.assign({}, values))
              .then(res => {
                if (res.code === '0') {
                  this.msg = '开卡成功！'
                  this.msgType = 'success'
                  // this.canQuery()
                } else {
                  this.msg = res.message
                  this.msgType = 'error'
                  //this.vehicleNo = ''
                }
              })
              .catch(e => { })
              .finally(() => {
                this.confirmLoading = false
                Bus.$emit('showSpinning', false)
              })
          } else if (this.tabkey == 6) {
            grantCardRecoveryCard(Object.assign({}, values))
              .then(res => {
                if (res.code === '0') {
                  this.msg = '收卡成功！'
                  this.msgType = 'success'
                } else {
                  this.msg = res.message
                  this.msgType = 'error'
                }
              })
              .catch(e => { })
              .finally(() => {
                this.confirmLoading = false
                Bus.$emit('showSpinning', false)
              })
          }
        } else {
          Bus.$emit('showSpinning', false)
          this.msg = '请输入相关信息'
          this.msgType = 'info'
        }
      })
    },
    changeBus() {
      console.log('=======666======')
    },
    changeMsg(e, str) {
      const road = this.form.getFieldValue('road');
      if (str && str === 'car' && !road){
        this.$notification.error({
          message: '请选择通道'
        })
        return false
      }
      console.log('=======触发复制======')
      this.msg = null
      // 触发赋值
      this.activeon++
      console.log("=====jin")
      this.vehicleNo = ''
      new Promise(resolve => {
        const data = cardvehicleList({ road }).then(res => { return res.data })
        resolve(data)
      }).then(res => {
        console.log("==y=" + res[0])

        this.vehicleNo = res[0]

      })


    },
    cardVoEnterRecovery(e) {
      e.target.value = e.target.value.toUpperCase()
      e.target.select()
      this.recoveryCardQuery()
    },
    recoveryCardQuery() {
      this.recoverymdl = {}
      Bus.$emit('showSpinning', true, '收卡中...')
      let reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g')
      if (reg.test(this.recoveryCard)) {
        this.msg = '卡号不能有汉字'
        this.msgType = 'error'
        Bus.$emit('showSpinning', false)
        return
      }
      recoveryCardCanQuery({ cardNo: this.recoveryCard }).then(res => {
        if (res.data && res.data.length > 0) {
          this.msg = null
          this.activeon++
          this.recoverymdl = res.data[0]
          this.recovery = true
          new Promise(resolve => {
            const data = recovercardvehicleList().then(res => { return res.data })
            resolve(data)
          }).then(res => {
            console.log("==y=" + res[0])

            this.recoveryCarNo = res[0]

          })
        } else {
          this.msg = '未查到可收卡信息，请核对卡号'
          this.msgType = 'warning'
          this.activeon++
        }
        Bus.$emit('showSpinning', false)
      })
    },
    handleRecoveryOk(record) {
      this.msg = null
      this.confirmLoading = true
      Bus.$emit('showSpinning', true, '收卡中...')
      // 表单验证
      // this.form = this.$form.createForm(this)
      grantCardRecoveryCard({ logisticsNo: record })
        .then(res => {
          if (res.code === '0') {
            this.msg = '收卡成功！'
            this.msgType = 'success'
          } else {
            this.msg = res.message
            this.msgType = 'error'
            // this.$message.error(res.message)
          }
        })
        .catch(e => { })
        .finally(() => {
          Bus.$emit('showSpinning', false)
          this.confirmLoading = false
        })
    },
    recoveryCancel() {
      this.confirmLoading = false
    },
    printPreview(record) {
      Bus.$emit('showSpinning', true, '打印中...')
      weighingOrder({ logisticsNo: record })
        .then(res => {
          if (res.code === '0') {
            var kk = res.data
            $.ajax({
              type: "post",
              url: "http://127.0.0.1:5050",
              data: kk,
              dataType: "json",
              success: function (data) {

              },
            })
            //  this.print = res.data
            //  this.print.inTime = formatDate(new Date(this.print.inTime), 'yyyy-MM-dd hh:mm:ss')
            // this.print.outTime = formatDate(new Date(new Date()), 'yyyy-MM-dd hh:mm:ss')
            // this.print.dbDate = formatDate(new Date(new Date()), 'yyyy-MM-dd')

            //  console.log( this.print.dbDate);
            // setTimeout(() => {
            //  this.createOneFormPage()
            // CLODOP.On_Return = function(TaskID, Value) {
            //  let count = 0
            // if (record.printCount != undefined && record.printCount != null && record.printCount != '') {
            //   count = parseInt(record.printCount)
            // }
            //  count = parseInt(count) + parseInt(Value)
            // record.printCount = count
            // weighingUpdate(record)
            //}
            //   this.LODOP.PREVIEW()
            //  }, 100);
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(e => {
          console.log(e)
        })
        .finally(z => {
          Bus.$emit('showSpinning', false)
        })
    },
    createOneFormPage() {
      this.LODOP = getLodop(this.downloadUrl)
      if (this.LODOP) {
        this.LODOP.PRINT_INIT('磅单打印面板')
        this.LODOP.SET_PRINT_STYLE('FontSize', 18)
        this.LODOP.SET_PRINT_STYLE('Bold', 1)
        this.LODOP.ADD_PRINT_HTM(0, 0, 400, 400, document.getElementById('dy01').innerHTML)
        this.LODOP.SET_PREVIEW_WINDOW(1, 2, 1, 460, 400, '磅单打印预览.打印')
        this.LODOP.SET_PRINT_PAGESIZE(3, '214mm', '93mm', "CreateCustomPage");
      }

    },
    tabChange(key) {
      this.msg = null
      this.tabkey = key
      this.canGrantCardList = []


      //为了公平，让你先跑100毫秒
      setTimeout(() => {
        if (key == 2) {
          this.form.setFieldsValue({road: localStorage.getItem('road')})
        }
        this.$refs['cardNo' + key].focus()
        console.log("日志：" + key)
        //  if (this.$refs['cardNo' + key].value) {
        //   this.$refs['cardNo' + key].value = this.$refs['cardNo' + key].value.toUpperCase()
        // }
        this.$refs['cardNo' + key].value = ''
        // this.$refs['cardNo' + key].select()
      }, 100)
    },
    changeRoad (e) {
      this.form.setFieldsValue({'cardNo': ''})
      localStorage.setItem('road', e.target.value)
    }
  }
}
</script>

<style>
.btn {
  margin-left: 40%;
}
.cardno {
  ime-mode: inactive;
}
.example {
  z-index: 9999;
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  border-radius: 4px;
  margin-bottom: 20px;
  padding: 30px 50px;
  margin: 20px 0;
}
.grant-list-box {
  position: relative;
}
.tipspan {
  background-color: #fff;
  position: absolute;
  top: -11px;
  left: 40px;
  z-index: 999;
}
.item-chick {
  width: 50px;
  display: table-cell;
  position: relative;
  margin: 0 auto;
}
.item-ckb {
  position: absolute;
  top: 50%;
  left: 15px;
  /* 这里有兼容性问题 */
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
}
.item-div {
  width: 1150px;
  display: table-cell;
  border: 1px dashed #888;
}
.stable {
  width: 100%;
}
.stable th {
  width: 8%;
  text-align: right;
  padding-right: 10px;
}
.stable td {
  width: 25%;
}
</style>
